
const TeamSection = () => {
  const team = [
    {
      name: "Dickie Paterson",
      role: "Founder & CEO",
      bio: "15+ years of growing e-commerce companies with deep expertise in scaling online businesses.",
      image: "https://static.readdy.ai/image/352cce8cf532226003c93d0e98b623eb/9b531a023a07da857c413e8d71a39bc2.jpeg"
    },
    {
      name: "Jessica Hanson",
      role: "Logistics Director",
      bio: "International shipping expert who's navigated customs regulations across 25+ countries.",
      image: "https://static.readdy.ai/image/352cce8cf532226003c93d0e98b623eb/e080806733a557c6570ec29b85769db5.jpeg"
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Meet the Team Behind Your Success
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our expert team brings together deep e-commerce experience and logistics expertise 
            to help your business dominate online rankings and scale across the US market.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 gap-12 max-w-4xl mx-auto">
          {team.map((member, index) => (
            <div key={index} className="text-center group">
              <div className="relative mb-6">
                <img 
                  src={member.image}
                  alt={member.name}
                  className="w-48 h-48 rounded-full mx-auto object-cover shadow-lg group-hover:shadow-xl transition-shadow duration-300"
                />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">{member.name}</h3>
              <p className="text-indigo-600 font-medium mb-3">{member.role}</p>
              <p className="text-gray-600 text-sm leading-relaxed">{member.bio}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
